import {UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormClearHybridEnginePowerFieldsActionParams {
  form: UseFormReturn<BaseVehicle>;
  previousFuelType: string | null;
}

/**
 * Clears combustion/electric engine power fields when transitioning away from the hybrid fuel type
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and previous fuel type value
 */
export const formClearHybridEnginePowerFieldsAction = (
  _context: unknown,
  params: FormClearHybridEnginePowerFieldsActionParams
): void => {
  const {form, previousFuelType} = params;

  const values = form.getValues();
  const currentFuelType = values.fuelType?.[0] ?? null;

  const wasHybrid = previousFuelType === 'FUELTYPE_HYBRID';
  const isCurrentHybrid = currentFuelType === 'FUELTYPE_HYBRID';

  if (wasHybrid && !isCurrentHybrid) {
    form.setValue('powerCombustionEngine', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    form.setValue('powerElectricEngine', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
  }
};
